import orgIsInSubscriptionState from './orgIsInSubscriptionState'
import SUBSCRIPTION_STATES from '../constants/subscriptionStates'

// Two single-state calls on purpose: a single-state INACTIVE call is what makes
// orgIsInSubscriptionState fail closed when the status is not cached yet.
const orgIsPayLocked = (orgId, status) =>
  orgIsInSubscriptionState([SUBSCRIPTION_STATES.INACTIVE], orgId, status) ||
  orgIsInSubscriptionState([SUBSCRIPTION_STATES.PENDING], orgId, status)

export default orgIsPayLocked
